import { ReactNode } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Grid2,
  useMediaQuery,
  useTheme
} from "@mui/material";
import {
  MRT_EditActionButtons as MRTEditActionButtons,
  MRT_Row,
  MRT_TableInstance
} from "material-react-table";
import { UserManagementRow } from "./typings/user-management.type";
import { TransitionForSlideoutPanel } from "../../../components/SlideoutPanel/SlideoutPanelTransition.component";

export function SlidePanelCreateEditUserManagement({
  table,
  row,
  internalEditComponents,
  headline
}: Readonly<{
  table: MRT_TableInstance<UserManagementRow>;
  row: MRT_Row<UserManagementRow>;
  internalEditComponents: ReactNode[];
  headline: string;
}>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const createOrEditDialogStyle = {
    height: "calc(-64px + 100vh)",
    maxHeight: "calc(-64px + 100vh)",
    maxWidth: isMobile ? "inherit" : "50vw",
    position: "absolute",
    right: 0,
    margin: 0,
    width: isMobile ? "100%" : "30vw",
    padding: 3,
    top: "64px"
  };

  return (
    <Dialog
      open
      data-testid="user-management-edit-row-dialog"
      slotProps={{ paper: { sx: { ...createOrEditDialogStyle } } }}
      transitionDuration={400}
      slots={{ transition: TransitionForSlideoutPanel }}
    >
      {/* edit user management dialog contents */}
      <DialogTitle variant="h4">{headline}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", mt: 2 }}>
        <Grid2 container data-testid="edit-user-management-dialog-contents" columnGap={4}>
          <Grid2 container size={{ xs: 12 }} rowGap={3.5}>
            {/* first name */}
            {internalEditComponents[1]}
            {/* surname */}
            {internalEditComponents[2]}
            {/* email */}
            {internalEditComponents[3]}
            {/* supervisor info */}
            {internalEditComponents[4]}
            {/* company */}
            {internalEditComponents[5]}
            {/* department */}
            {internalEditComponents[6]}
            {/* status */}
            {internalEditComponents[7]}
            {/* isFirstAidUser */}
            {internalEditComponents[8]}
            {/* participatesInMobileWorking */}
            {internalEditComponents[9]}
          </Grid2>
        </Grid2>
      </DialogContent>

      <Divider sx={{ mt: 3, mb: 3, opacity: "0.6" }} />
      <DialogActions>
        <MRTEditActionButtons variant="text" table={table} row={row} />
      </DialogActions>
    </Dialog>
  );
}
